module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-lincoln-24.0e173ea8.jpg";